import { DefineNumberFormat, createI18n } from "vue-i18n";

import { locale as fr } from "@/core/config/i18n/locale.fr";
import { locale as en } from "@/core/config/i18n/locale.en";
import { locale as nl } from "@/core/config/i18n/locale.nl";
import { locale as de } from "@/core/config/i18n/locale.de";

export const EN_LANGUAGE = "en-GB";
export const FR_LANGUAGE = "fr-FR";
export const NL_LANGUAGE = "nl-BE";
export const DE_LANGUAGE = "de-DE";
export const FALLBACK_LANGUAGE = EN_LANGUAGE;
export const DEFAULT_LANGUAGE = FR_LANGUAGE;

const EUR_CURRENCY = "EUR";
const GBP_CURRENCY = "GBP";
export const DEFAULT_CURRENCY = EUR_CURRENCY;

const messages = {
  [FR_LANGUAGE]: fr,
  [EN_LANGUAGE]: en,
  [NL_LANGUAGE]: nl,
  [DE_LANGUAGE]: de,
};

const numberFormats: { [key: string]: DefineNumberFormat } = {
  [FR_LANGUAGE]: {
    currency: {
      style: "currency",
      currency: EUR_CURRENCY,
      currencyDisplay: "symbol",
    },
  },
  [EN_LANGUAGE]: {
    currency: {
      style: "currency",
      currency: GBP_CURRENCY,
      currencyDisplay: "symbol",
    },
  },
  [NL_LANGUAGE]: {
    currency: {
      style: "currency",
      currency: EUR_CURRENCY,
      currencyDisplay: "symbol",
    },
  },
  [DE_LANGUAGE]: {
    currency: {
      style: "currency",
      currency: EUR_CURRENCY,
      currencyDisplay: "symbol",
    },
  },
};

export const datetimeFormats: { [key: string]: any } = {
  [FR_LANGUAGE]: {
    date: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    },
    hour: {
      hour: "numeric",
      minute: "numeric",
    },
    dateTime: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
  },
  [EN_LANGUAGE]: {
    date: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    },
    hour: {
      hour: "numeric",
      minute: "numeric",
    },
    dateTime: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
  },
  [NL_LANGUAGE]: {
    date: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    },
    hour: {
      hour: "numeric",
      minute: "numeric",
    },
    dateTime: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
  },
  [DE_LANGUAGE]: {
    date: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    },
    hour: {
      hour: "numeric",
      minute: "numeric",
    },
    dateTime: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
  },
};

const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LANGUAGE,
  globalInjection: true,
  fallbackLocale: FALLBACK_LANGUAGE,
  messages,
  numberFormats,
  datetimeFormats,
});

export default i18n;
